var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 8.125C10.625 7.77982 10.3452 7.5 10 7.5C9.65482 7.5 9.375 7.77982 9.375 8.125V12.8661L7.94194 11.4331C7.69786 11.189 7.30214 11.189 7.05806 11.4331C6.81398 11.6771 6.81398 12.0729 7.05806 12.3169L9.55806 14.8169C9.80214 15.061 10.1979 15.061 10.4419 14.8169L12.9419 12.3169C13.186 12.0729 13.186 11.6771 12.9419 11.4331C12.6979 11.189 12.3021 11.189 12.0581 11.4331L10.625 12.8661V8.125Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5V5.625L11.875 0H5C3.61929 0 2.5 1.11929 2.5 2.5V17.5C2.5 18.8807 3.61929 20 5 20H15C16.3807 20 17.5 18.8807 17.5 17.5ZM11.875 3.75C11.875 4.78553 12.7145 5.625 13.75 5.625H16.25V17.5C16.25 18.1904 15.6904 18.75 15 18.75H5C4.30964 18.75 3.75 18.1904 3.75 17.5V2.5C3.75 1.80964 4.30964 1.25 5 1.25H11.875V3.75Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.3e71c5464f0b9961f2bd094a93f5c97e.svg";
export { ForwardRef as ReactComponent };